import React, { useEffect } from "react";
import Hero from "../components/Hero";
//import Products from "../components/Products";
//import CompanyInfo from "../components/CompanyInfo";
import Equipment from "../components/Equipment";
import Map from "../components/Map";

const Home: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Home";
  }, []);

  return (
    <>
      <Hero />
      {/*
      <Products />
      
      <CompanyInfo />
      */}
      <Equipment />
      <Map />
    </>
  );
};

export default Home;
